<template>
	<div v-if="!snapshot.readonly" class="d-flex flex-wrap align-center ga-2">
		<template v-if="isNegoPhase(phase)">
			<v-btn v-if="offerRef.offerKey && canAddProducts" prepend-icon="add" color="primary" @click="ops.addLocalProducts(offerRef)">{{ t('AddProductOfferPromoLocale') }}</v-btn>
			<template v-if="phase !== PHASE.PENDING">
				<v-btn variant="outlined" color="primary" @click="ops.negotiateAll(offerRef)">{{ t('PromoNegotiateAll') }}</v-btn>
				<v-btn variant="outlined" color="error" @click="ops.clearAllNegos(offerRef)">{{ t('PromoDeleteAllNegos') }}</v-btn>
			</template>
			<v-spacer />
			<v-btn v-if="hasOrderable && !orderHidden" prepend-icon="shopping_cart" color="primary" :disabled="!canOrder" @click="ops.orderOffer(offerRef)">{{ t('Checkout') }}</v-btn>
		</template>
		<template v-else-if="phase === PHASE.STATEMENT">
			<v-btn prepend-icon="visibility" variant="outlined" color="success" :disabled="statementBlocked" @click="ops.setAllPresence(offerRef, PRESENCE.PRESENT)">{{ t('PromoAllPresent') }}</v-btn>
			<v-btn prepend-icon="visibility_off" variant="outlined" color="error" :disabled="statementBlocked" @click="ops.setAllPresence(offerRef, PRESENCE.ABSENT)">{{ t('PromoAllAbsent') }}</v-btn>
			<v-btn prepend-icon="restart_alt" variant="outlined" color="primary" :disabled="statementBlocked" @click="ops.setAllPresence(offerRef, PRESENCE.NONE)">{{ t('PromoResetPresence') }}</v-btn>
		</template>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { usePromoStep } from '@/composables/usePromoStep';
import { PHASE, isNegoPhase } from '@/utils/domain/promo/promoPhase';
import { PRESENCE } from '@/utils/domain/promo/promoStatement';
import { canOrderOffer, hasOrderableProducts, isOrderHidden } from '@/utils/domain/promo/promoOrder';
import { isStatementBlocked } from '@/utils/domain/promo/promoForecast';
import { canAddLocalProducts } from '@/utils/domain/promo/promoLocalOffer';
import { getOfferInfo } from '@/utils/domain/promo/promoModel';

const props = defineProps({
	campaign: { type: Object, required: true },
	offer: { type: Object, required: true },
	offerRef: { type: Object, required: true },
	phase: { type: String, required: true },
});

const { snapshot, ops, t } = usePromoStep();

const hasOrderable = computed(() => hasOrderableProducts(props.offer));
const canOrder = computed(() => canOrderOffer(snapshot.value, props.offerRef));
const orderHidden = computed(() => isOrderHidden(snapshot.value, props.offerRef));
const statementBlocked = computed(() => isStatementBlocked(snapshot.value, props.campaign, props.offerRef));
const canAddProducts = computed(() => canAddLocalProducts(snapshot.value, getOfferInfo(snapshot.value, props.offerRef.offerKey)));
</script>
